import { ButtonHTMLAttributes } from 'react';
import {
  components,
  ControlProps,
  GroupBase as DefaultGroupBase,
} from 'react-select';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { DownloadIcon } from 'src/components/icons/DownloadIcon';
import { useTheme } from 'styled-components';
import { ButtonWithIcon } from '../DropdownSelect.styles';
import { DefaultOption } from './DropdownOptions';

export const DropdownControl = <
  Option extends DefaultOption = DefaultOption,
  GroupBase extends DefaultGroupBase<Option> = DefaultGroupBase<Option>,
>(
  props: ControlProps<Option, boolean, GroupBase> & {
    tabIndex?: number;
    size?: 'small' | 'medium' | 'large';
    buttonIcon?: string;
    buttonVariant?: 'primary' | 'secondary' | 'tertiary';
    highlightButtonWhenOpen?: boolean;
    downloadIcon?: boolean;
  },
) => {
  const theme = useTheme();
  const { buttonText, routing, menuIsOpen } = props.selectProps;
  const {
    innerProps: divInnerProps,
    buttonIcon,
    buttonVariant,
    highlightButtonWhenOpen,
    downloadIcon,
  } = props;
  const innerProps = divInnerProps as ButtonHTMLAttributes<HTMLButtonElement>;

  return routing && buttonText === 'More' ? (
    <ButtonWithIcon
      {...innerProps}
      size={props.size ?? 'medium'}
      variant="secondary"
      width="140px"
      onClick={() => null}
      data-testid={`${props.selectProps['data-testid']}-button`}
      tabIndex={props.tabIndex}
      noTextWrap
    >
      More
      {props.children}
    </ButtonWithIcon>
  ) : buttonText ? (
    <ButtonWithIcon
      {...innerProps}
      size={props.size ?? 'medium'}
      variant={buttonVariant ?? 'secondary'}
      onClick={() => null}
      data-testid={`${props.selectProps['data-testid']}-button`}
      tabIndex={0}
      noBorder={buttonVariant ? false : true}
      active={highlightButtonWhenOpen && menuIsOpen}
      noTextWrap
    >
      {buttonIcon && (
        <StyledIconInButton
          className={buttonIcon}
          size={props.size ?? 'medium'}
          color={theme.atlas.semantic.color.type.default}
          position="left"
        />
      )}
      {downloadIcon && <DownloadIcon />}
      {buttonText}
      {props.children}
    </ButtonWithIcon>
  ) : (
    <components.Control {...props}></components.Control>
  );
};
